<template>
  <th v-if="isHeader">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-checkbox
          @change="toggleAllCheckbox($event)"
          v-on="on"
          :input-value="isAllItemsSelected()"
          :indeterminate="isIndeterminate"
          hide-details
        ></v-checkbox>
      </template>
      <span>{{ this.haveAllIdsOnAllPages()
               ? $t('app.allItemsOnAllPages')
               : $t('app.allItemsOnThisPage')
      }}</span>
    </v-tooltip>
  </th>
  <td v-else>
    <v-checkbox
      @change="toggleCheckbox(rowData, $event)"
      :input-value="isSelected(rowData)"
      hide-details
    ></v-checkbox>
  </td>
</template>
<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin.vue';

export default {
  name: 'vuetable-material-design-checkbox',
  mixins: [
    VuetableFieldMixin,
  ],
  data() {
    return {
      isIndeterminate: false,
      amountOfSelectedItems: 0,
    };
  },
  methods: {
    toggleCheckbox(dataItem, checked) {
      this.vuetable.onCheckboxToggled(checked, this.rowField.name, dataItem);
    },
    haveAllIdsOnAllPages() {
      return typeof this.vuetable.$parent.$parent.$data.allIdsOnAllPages !== 'undefined';
    },
    toggleAllCheckbox(checked) {
      if (this.haveAllIdsOnAllPages()) {
        this.vuetable.$parent.$parent.$data.allIdsOnAllPages.forEach((item) => {
          if (checked) this.vuetable.selectId(item);
          else this.vuetable.unselectId(item);
        });
      } else {
        this.vuetable.onCheckboxToggledAll(checked);
      }
    },
    isSelected(rowData) {
      return this.vuetable.isSelectedRow(rowData[this.vuetable.trackBy]);
    },
    isAllItemsSelected() {
      if (!this.vuetable.tableData) {
        return null;
      }

      // checkbox marks all items on all pages
      if (this.haveAllIdsOnAllPages()) {
        this.amountOfSelectedItems = this.vuetable.$parent.$parent.$data.selectedRows.length;

        if (this.vuetable.$parent.$parent.$data.selectedRows.length === 0) {
            this.isIndeterminate = false;
            return false;
        }
        if (
            this.vuetable.$parent.$parent.$data.selectedRows.length
            < this.vuetable.$parent.$parent.$data.allIdsOnAllPages.length
        ) {
            this.isIndeterminate = true;
            return true;
        }
        this.isIndeterminate = false;
        return true;
      }

      // checkbox only marks the current page
      const idColumn = this.vuetable.trackBy;
      const selected = this.vuetable.tableData.filter(
        (item) => this.vuetable.isSelectedRow(item[idColumn]),
      );
      this.amountOfSelectedItems = selected.length;

      /* eslint-disable no-else-return */
      if (selected.length <= 0) {
        this.isIndeterminate = false;

        return false;
      } else if (selected.length < this.vuetable.perPage) {
        this.isIndeterminate = true;

        return true;
      }
      /* eslint-enable */

      this.isIndeterminate = false;
      return true;
    },
  },
};
</script>
<style>
</style>
